import React from 'react';
import { ReactViewerConnected } from 'reactApp/ui/ReactViewer/ReactViewer';
import { renderModalDialog } from 'reactApp/utils/createDialogToolkit';
import { noop } from 'reactApp/utils/helpers';

const ReactViewer = ({ isPublic = false, isStock = false, isMountedFolder = false, onClose = noop }) => {
    return (
        <ReactViewerConnected
            isPublic={isPublic}
            isStock={isStock}
            isMountedFolder={isMountedFolder}
            showEditorHeader
            gaCategory="newv"
            isViewer
            enablePreload
            onClose={onClose}
        />
    );
};

export const renderReactViewer = renderModalDialog(ReactViewer, 'ReactViewer');
